/**
 * TagChip Component
 * Clickable tag chip that navigates to search page filtered by tag.
 */

import { useNavigate } from "react-router-dom"
import type { SearchTab } from "@/features/search/types/search.types"
import { cn } from "@/lib"

interface TagChipProps {
  tag: string
  tab: SearchTab
  className?: string
}

export function TagChip({ tag, tab, className }: TagChipProps) {
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation()
        navigate(`/search?q=${encodeURIComponent(tag)}&tab=${tab}`)
      }}
      className={cn(
        "text-[13px] leading-[20px] border border-text-primary rounded-md px-2.5 py-2 text-text-primary whitespace-nowrap cursor-pointer transition-colors hover:bg-accent hover:text-accent-foreground",
        className,
      )}
    >
      {tag}
    </button>
  )
}
